// extracted by mini-css-extract-plugin
export var active = "_8x-a";
export var activeIndicator = "_8x-9";
export var disabled = "_8x-b";
export var fullWidth = "_8x-2";
export var lg = "_8x-7";
export var md = "_8x-6";
export var redoButtonTabGroup = "_8x-0";
export var sm = "_8x-5";
export var tabButton = "_8x-4";
export var tabButtonsContainer = "_8x-1";
export var themeDestructive = "_8x-d";
export var themeNormal = "_8x-c";
export var themeSuccess = "_8x-e";
export var xl = "_8x-8";
export var xs = "_8x-3";